import { Menu } from "./menu.js";
import { styles } from "./menu.styles.js";
import { template } from "./menu.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-menu>
 */
export const definition = Menu.compose({
    name: `${DesignSystem.prefix}-menu`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=menu.definition.js.map